import { render } from "./index.vue?vue&type=template&id=260c534b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\takeda\\ui\\takeda_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/component/table/src/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "260c534b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('260c534b', __exports__)) {
    console.log('reload')
    api.reload('260c534b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=260c534b", () => {
    console.log('re-render')
    api.rerender('260c534b', render)
  })

}


export default __exports__